<template>
  <div>
    <AppHeader />
    <div class="container">
      <div class="page-title" style="margin-bottom: 0.33rem">
        {{ $t('wallet') }}
      </div>
      <div class="list1" v-if="$store.state.user_info">
        <div class="item">
          <div class="flexable">
            <div class="text" :class="'text0'">
              <div class="label up">{{ $t('web5token') }}</div>
              <div class="value">{{ $store.state.user_info.web5_score }}</div>
            </div>
            <!-- <div class="btns">
              <el-button type="primary" size="sm">Deposit</el-button>
              <el-button type="default" size="sm">Withdraw</el-button>
            </div> -->
          </div>
        </div>
        <div class="item">
          <div class="flexable">
            <div class="text" :class="'text1'">
              <div class="label up">{{ $t('krazetoken') }}</div>
              <div class="value">{{ $store.state.user_info.kraze_token }}</div>
            </div>
            <!-- <div class="btns">
              <el-button type="primary" size="sm">Deposit</el-button>
              <el-button type="default" size="sm">Withdraw</el-button>
            </div> -->
          </div>
        </div>
        <div class="item ac">
          <span class="arrow-right" @click="handleTransfer">{{
            $t('add.text87')
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BabeWallet',
  components: {},
  data() {
    return {}
  },
  methods: {
    handleTransfer() {
      this.handleRoute('/babe/transferlist')
    },
    handleRoute(path, item) {
      if (item) {
        this.$router.push({ path: path, query: { rec_code: item.rec_code } })
      } else {
        this.$router.push({ path: path })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/babe/wallet.vue